module.exports = __webpack_public_path__ + "static/media/sistema-light.092bdf38.jpg";